/**
 * BusinessRole Enum
 */
export enum BusinessRole {
  HEAD_OF_PCO = 'HEAD_OF_PCO',
  CONTROLLER = 'CONTROLLER',
  PLANNER = 'PLANNER'
}

/**
 * Formats a BusinessRole enum value into a human-readable string
 * @param role - The BusinessRole enum value to format
 * @returns A formatted string representation of the business role
 *
 * @example
 * formatBusinessRole(BusinessRole.HEAD_OF_PCO) // returns "Head of PCO"
 * formatBusinessRole(BusinessRole.CONTROLLER) // returns "Controller"
 * formatBusinessRole(BusinessRole.PLANNER) // returns "Planner"
 */
export function formatBusinessRole(role: BusinessRole): string {
  switch (role) {
    case BusinessRole.HEAD_OF_PCO:
      return 'Head of PCO';
    case BusinessRole.CONTROLLER:
      return 'Controller';
    case BusinessRole.PLANNER:
      return 'Planner';
    default:
      // Handle case where role might be undefined or not in enum
      return role ? String(role).replace(/_/g, ' ').toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase()) : 'Unknown';
  }
}
